/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSliderProps } from './type';

export const sliderDefaultProps: TdSliderProps = {
  disabled: undefined,
  label: false,
  max: 100,
  min: 0,
  range: false,
  showExtremeValue: false,
  step: 1,
  theme: 'default',
  defaultValue: 0,
};
